class Login {
	constructor(
		public readonly email: string,
		public readonly password: string,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			email: this.email,
			password: this.password,
		};
	}
}

export default Login;
